import React from 'react';
import { confirmable, createConfirmation } from 'react-confirm';

import Popup from 'components/Popup';
import ShortlistShareDialogBody from 'scenes/Dialog/components/ShortlistShareDialog/components';
import { POPUP_STYLES } from 'constants/popup-styles';
import { UxHelpers } from 'helpers/ux-helpers';

const ShortlistShareDialog = props => {
  const { id, title, show, proceed, dismiss, cancel } = props;

  const proceedHandler = data => {
    proceed(data);
    UxHelpers.overflowLock('unlock');
  };

  const dismissHandler = () => {
    dismiss();
    UxHelpers.overflowLock('unlock');
  };

  const cancelHandler = data => {
    cancel(data);
    UxHelpers.overflowLock('unlock');
  };

  return (
    show && (
      <Popup
        actions={{
          dismiss,
          proceed,
        }}
        title={title}
        bodyRender={
          <ShortlistShareDialogBody
            id={id}
            proceed={proceedHandler}
            dismiss={dismissHandler}
            cancel={cancelHandler}
          />
        }
        compact={true}
        popupStyles={POPUP_STYLES.formPopupStyles}
        popupTitleStyles={POPUP_STYLES.formTitleStyles}
        popupInnerStyles={POPUP_STYLES.formInnerStyles}
        modeless={false}
      />
    )
  );
};

export default createConfirmation(confirmable(ShortlistShareDialog));
